import AbstractOperatorApplicationPlatform from "~/operatorApplication/ts/platform/AbstractOperatorApplicationPlatform";
import LatestElectronOperatorApplicationPlatform
    from "~/operatorApplication/ts/platform/electron/LatestElectronOperatorApplicationPlatform";
import WebOperatorApplicationPlatform from "~/operatorApplication/ts/platform/web/WebOperatorApplicationPlatform";
import Electron22OperatorApplicationPlatform
    from "~/operatorApplication/ts/platform/electron/Electron22OperatorApplicationPlatform";
import ElectronPlatform from "~/operatorApplication/electron/src/ElectronPlatform";

let OperatorApplicationPlatform: AbstractOperatorApplicationPlatform;

let userAgent = navigator.userAgent.toLowerCase();
if (userAgent.indexOf(' electron/') > -1) {
    if (ElectronPlatform.isUseLatestElectron) {
        OperatorApplicationPlatform = new LatestElectronOperatorApplicationPlatform();
    } else {
        OperatorApplicationPlatform = new Electron22OperatorApplicationPlatform();
    }
} else {
    OperatorApplicationPlatform = new WebOperatorApplicationPlatform();
}

export default OperatorApplicationPlatform;